import mark from '../icons/mark.svg?raw';

/** "The R": the app's icon (tool/icon/make_icons.py draws the same geometry). */
export function Mark({ className = 'mark' }: { className?: string }) {
  return <span className={className} role="img" aria-label="Routr" dangerouslySetInnerHTML={{ __html: mark }} />;
}
